import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgHttpLoaderModule} from 'ng-http-loader';
import {InlineSVGModule} from "ng-inline-svg-2";
import localeEt from '@angular/common/locales/et';
import {CommonModule, registerLocaleData} from '@angular/common';
import {CommonSharedModule, AppConfig, MesHttpStatusHandlerService, GlobalErrorHandlerService} from 'common-shared';
import {RouterModule} from '@angular/router';
import {ActionBarModule} from './components/action-bar/action-bar.module';
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {TranslocoModule, TranslocoService} from "@jsverse/transloco";
import {TranslocoWithKeyService} from "./core/services/transloco-with-key.service";
import {FormsModule} from "@angular/forms";
import {NgxGraphModule} from "@swimlane/ngx-graph";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgOptionHighlightModule} from "@ng-select/ng-option-highlight";

registerLocaleData(localeEt);

@NgModule({
  declarations: [],
  exports: [], imports: [CommonSharedModule,
    CommonModule,
    RouterModule,
    ActionBarModule,
    InlineSVGModule,
    NgHttpLoaderModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    TranslocoModule,
    FormsModule,
    NgbDropdownModule,
    NgxGraphModule,
    NgbModalModule,
    NgbCollapseModule,
    NgSelectModule,
    NgOptionHighlightModule], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class WebSharedModule {
  static forRoot(config: AppConfig): ModuleWithProviders<WebSharedModule> {
    return {
      ngModule: WebSharedModule,
      providers: [
        MesHttpStatusHandlerService,
        {provide: AppConfig, useValue: config},
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandlerService
        },
        {provide: 'config', useValue: config},
        {provide: TranslocoService, useClass: TranslocoWithKeyService}
      ]
    };
  }
}

